import { Navigate } from 'react-router';
import { ApiError } from '../lib/api';
import { useMe } from '../lib/session';
import { RouteSpinner } from './guards';

/**
 * `/` decides where you belong (doc 05): Welcome when signed out, `/start` with no
 * family yet, otherwise Home.
 */
export function RootRedirect() {
  const { data: me, isPending, error } = useMe();

  if (isPending) return <RouteSpinner />;
  if (error instanceof ApiError && error.code === 'UNAUTHENTICATED')
    return <Navigate to="/welcome" replace />;
  if (error) throw error;
  if (me?.user.isArchived) return <Navigate to="/restore-account" replace />;
  if (!me || me.families.length === 0) return <Navigate to="/start" replace />;
  return <Navigate to="/home" replace />;
}
